import inDOM from 'dom-helpers/canUseDOM'

export const getScrollBarWidth = () => {
  if (!inDOM) return 0
  // See src/server/middleware/headScript.js for definition of document.scrollBarWidth.
  return document.scrollBarWidth
}
